import { OnInit, ElementRef } from '@angular/core';
import { BsModalRef, BsModalService } from '../../../node_modules/ngx-bootstrap';
import { LoginService } from '../services/login.service';
import { Globals } from '../objects/Globals';
import { Router } from '@angular/router';
import { TokenManager } from '../Globals';
import { Subject } from 'rxjs';
import { ThemeSettingService } from '../services/theme-setting.service';
import { ForgotLoginComponent } from '../forgot-login/forgot-login.component';
import { ConfirmationService } from '../services/confirmation.service';
import { ToasterService } from 'angular2-toaster';
import { LoadingComponent } from '../loading/loading.component';
import { HeaderService } from '../services/header.service';
import { SessionTimerService } from '../services/session-timer.service';
var LoginModalComponent = /** @class */ (function () {
    function LoginModalComponent(loginService, globals, router, bsModalRef, modalRef, modalService, tokenManager, themeSettingService, confirmationService, toasterService, headerService, sessionTimerService) {
        this.loginService = loginService;
        this.globals = globals;
        this.router = router;
        this.bsModalRef = bsModalRef;
        this.modalRef = modalRef;
        this.modalService = modalService;
        this.tokenManager = tokenManager;
        this.themeSettingService = themeSettingService;
        this.confirmationService = confirmationService;
        this.toasterService = toasterService;
        this.headerService = headerService;
        this.sessionTimerService = sessionTimerService;
        this.submitted = false;
        this.isEmptyPassword = false;
        this.isBusy = false;
    }
    LoginModalComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.loaderConfig = this.themeSettingService.getTheme();
        this.invalid = new Subject();
        setTimeout(function () { return _this.password.nativeElement.focus(); });
    };
    LoginModalComponent.prototype.onDecline = function () {
        this.bsModalRef.hide();
    };
    LoginModalComponent.prototype.onConfirm = function (password) {
        if (password) {
            this.isEmptyPassword = false;
            if (!this.submitted) {
                this.submitted = true; // prevent form submit called twice
                this.login(this.bsModalRef.content.username, password);
            }
        }
        else {
            this.isEmptyPassword = true;
        }
    };
    LoginModalComponent.prototype.login = function (username, password) {
        var _this = this;
        this.isBusy = true;
        var param = [];
        param.push({ name: 'username', value: username });
        param.push({ name: 'password', value: password });
        if (this.tokenManager.retrieve("BRNHoldKey")) {
            var value = this.tokenManager.retrieve("BRNHoldKey").replace(/["']/g, "");
            if (value != "null") {
                param.push({ name: 'holdKey', value: this.tokenManager.retrieve("BRNHoldKey").replace(/["']/g, "") });
            }
        }
        else if (this.tokenManager.retrieve("BRNActionKey")) {
            var value = this.tokenManager.retrieve("BRNActionKey").replace(/["']/g, "");
            if (value != "null") {
                param.push({ name: 'holdKey', value: this.tokenManager.retrieve("BRNActionKey").replace(/["']/g, "") });
            }
        }
        this.loginService.login(param).subscribe(function (result) {
            _this.bsModalRef.hide();
            if (result) {
                if (result.Session) {
                    _this.tokenManager.store("BRNHoldKey", null);
                    _this.redirectHome(result);
                    _this.isBusy = false;
                }
                else {
                    setTimeout(function () {
                        _this.confirmationService.confirmNoInput('<span class="bold">Confirmation</span>', result.HoldMessage, ["CANCEL", "OK"]).subscribe(function (respond) {
                            var newParam = [];
                            var index = param.findIndex(function (x) { return x.name == "holdKey"; });
                            if (index > -1) {
                                newParam.push(param.find(function (x) { return x.name == "holdKey"; }));
                            }
                            if (respond.answer == "OK") {
                                var config = {
                                    keyboard: false,
                                    ignoreBackdropClick: true,
                                    class: 'modal-dialog-centered modal-loading',
                                    focus: false,
                                    animated: false
                                };
                                _this.isBusy = true;
                                _this.modalRef = _this.modalService.show(LoadingComponent, config);
                                _this.loginService.proceed(result.HoldId, true, newParam).subscribe(function (result) {
                                    if (result) {
                                        _this.tokenManager.store("BRNHoldKey", null);
                                        _this.redirectHome(result);
                                        _this.modalRef.hide();
                                        _this.isBusy = false;
                                    }
                                });
                            }
                            else if (respond.answer == "CANCEL") {
                                _this.loginService.proceed(result.HoldId, false, newParam).subscribe(function (result) {
                                    if (result) {
                                        _this.redirectHome(result);
                                        _this.isBusy = false;
                                    }
                                });
                            }
                        });
                    }, 500);
                }
            }
            else {
                _this.isBusy = false;
                _this.submitted = false;
                _this.invalid.next(true);
            }
        }, function (error) {
            _this.isBusy = false;
            _this.submitted = false;
            //this.tokenManager.store("BRNHoldKey", null)
        });
    };
    LoginModalComponent.prototype.redirectHome = function (result) {
        this.globals.Session = result;
        this.loginService.setSession(result);
        this.headerService.setSessionAlive(true);
        this.sessionTimerService.startSessionTimer();
        this.router.navigate(['/', 'home']);
        document.querySelectorAll('.body-content').item(0).classList.remove('mb-login');
        document.querySelectorAll(".body-content").item(0).classList.remove('default');
        document.querySelectorAll('.navbar').item(0).classList.remove('mb-login');
        this.invalid.next(false);
        this.globals.CardItems = [];
        this.tokenManager.delete("BRNCurrentMenu");
        if (this.globals.Session.Session.SessionId != null) {
            this.tokenManager.store('BRNSessionKey', this.globals.Session.Session.SessionId);
        }
        this.toasterService.clear();
    };
    LoginModalComponent.prototype.forgotLoginDetails = function () {
        var config = {
            keyboard: false,
            ignoreBackdropClick: true,
            class: 'modal-dialog-centered modal-forgot-login',
            focus: false
        };
        this.modalRef = this.modalService.show(ForgotLoginComponent, config);
        this.modalService.onHide.subscribe(function (reason) {
            if (document.querySelectorAll('.modal-backdrop').item(0)) {
                document.querySelectorAll('.modal-backdrop').item(0).classList.remove('layer');
            }
        });
        document.querySelectorAll('.modal-backdrop').item(0).classList.add('layer');
    };
    return LoginModalComponent;
}());
export { LoginModalComponent };
